import {DatePicker, datePicker} from "./DatePickerComponent";
import {datePickerPopupTemplateCaching} from "./DatePickerPopupCustomTemplate";
import {datePickerDayTemplateCaching} from "./DatePickerDayCustomTemplate";
import {datePickerMonthTemplateCaching} from "./DatePickerMonthCustomTemplate";

export default angular.module("tfApp.components.datepicker", [])
                      .component(DatePicker, datePicker())
                      .run(datePickerPopupTemplateCaching)
                      .run(datePickerDayTemplateCaching)
                      .run(datePickerMonthTemplateCaching)
                      .name;
